import {Component, EventEmitter, Input, OnChanges, Output, SimpleChange} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {Event} from "../../../../models/event";
import {Registration} from "../../../../models/registration";
import {BaseError} from "../../base-error";

@Component({
  selector: "registration-edit",
  templateUrl: "./registration-edit.component.html",
  styleUrls: ["./registration-edit.component.css"],
})
export class RegistrationEditComponent extends BaseError implements OnChanges {

  @Input() public serviceId: string;
  @Input() public registration: Registration;
  @Input() public determinantMapById: { [key: string]: string };
  @Output() public modalClosedEvent = new EventEmitter();
  public visible = false;

  constructor(toastr: ToastrService) {
    super(toastr);
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.serviceId && changes.serviceId.currentValue) {
      this.serviceId = changes.serviceId.currentValue;
    }
    if (changes.registration && changes.registration.currentValue) {
      this.registration = changes.registration.currentValue;
    }
  }

  public closeModal(event: Event) {
    this.modalClosedEvent.emit(event);
  }

}
